<template>
    <footer class="zain-footer">
        <div class="zain-footer__container">
            <div class="zain-footer__content">
                <!-- Logo -->
                <div class="zain-footer__logo">
                    <img src="@/assets/image/logoSvg.svg" alt="Zain">
                </div>

                <!-- Links -->
                <div class="zain-footer__links">
                    <router-link to="/">الرئيسية</router-link>
                    <router-link to="/contacts">اتصل بنا</router-link>
                    <router-link to="/Subscribes">اشترك الآن</router-link>
                </div>

                <!-- Divider -->
                <div class="zain-footer__divider"></div>

                <!-- Copyright -->
                <div class="zain-footer__copyright">
                    <p>Powered by <strong>Zain</strong> © {{ year }}</p>
                    <p class="zain-footer__designer">Designed by <span>Fenteo</span></p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'AppFooter',
    data() {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>

<style scoped>
.zain-footer {
    background: linear-gradient(135deg, #034635 0%, #0d6650 30%, #309d81 60%, #214d42 100%);
    padding: 40px 20px 30px;
    position: relative;
    overflow: hidden;
}

.zain-footer__container {
    max-width: 1200px;
    margin: 0 auto;
}

.zain-footer__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    position: relative;
    z-index: 2;
}

/* Logo */
.zain-footer__logo {
    margin-bottom: 10px;
}

.zain-footer__logo img {
    height: 45px;
    width: auto;
    /* Logo is white, visible on teal background */
}

/* Links */
.zain-footer__links {
    display: flex;
    align-items: center;
    gap: 30px;
    flex-wrap: wrap;
    justify-content: center;
}

.zain-footer__links a {
    color: rgba(255, 255, 255, 0.85);
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    position: relative;
}

.zain-footer__links a::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background: #4FD1C5;
    transition: width 0.3s ease;
}

.zain-footer__links a:hover {
    color: #fff;
}

.zain-footer__links a:hover::after {
    width: 100%;
}

/* Divider */
.zain-footer__divider {
    width: 100%;
    max-width: 300px;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    margin: 10px 0;
}

/* Copyright */
.zain-footer__copyright {
    text-align: center;
}

.zain-footer__copyright p {
    margin: 0;
    color: rgba(255, 255, 255, 0.7);
    font-size: 13px;
}

.zain-footer__copyright strong {
    color: #4FD1C5;
}

.zain-footer__designer {
    margin-top: 5px !important;
    font-size: 12px !important;
}

.zain-footer__designer span {
    color: #4FD1C5;
    font-weight: 600;
}


/* Responsive */
@media (max-width: 576px) {
    .zain-footer {
        padding: 30px 15px 25px;
    }

    .zain-footer__links {
        gap: 20px;
    }

    .zain-footer__links a {
        font-size: 13px;
    }

    .zain-footer__logo img {
        height: 35px;
    }

    .zain-footer__shape {
        display: none;
    }
}
</style>
